import { gql } from '@apollo/client'

const QueryGetEmailTrackingEventsByUserEmail = gql(`
    query getEmailTrackingEventsByUserEmail($userEmail: String!, $emailType: String, $limit: Int, $nextToken: String) {
      getEmailTrackingEventsByUserEmail( 
        userEmail: $userEmail
        emailType: $emailType
        limit: $limit
        nextToken: $nextToken
      ) {
      data {
        emailBody
        emailType
        events {
          eventType 
          createdAt
        }
        messageId
        updatedAt
        createdAt
        userEmail
      }
      nextToken
    }
}`)

export default QueryGetEmailTrackingEventsByUserEmail
